import Styles from "./styles/button.module.scss";

const Button = ({
  toolTipText,
  className,
  text,
  icon,
  type,
  imgSrc,
  disabled,
  style,
  loading,
  ...props
}) => {
  const getButtonType = ({ disabled, type }) => {
    if (disabled) {
      return Styles.disabled;
    }





    switch (type) {
      case "PRIMARY":
        return Styles.primary;
      case "SECONDARY":
        return Styles.secondary;
      case "TERTIARY":
        return Styles.tertiary;

        case "IMAGE":
          return Styles.imageBtn

      default:
        return Styles.primary;
    }
  };
  return (
    <button
      style={style}
      className={` ${getButtonType({ disabled, type })} ${
        Styles.tooltip
      } ${className}`}
      disabled={disabled}
      {...props}
    >
      {imgSrc && <img height={20} width={20} src={imgSrc} />}
      {text && <span>{loading ? "loading.." : text}</span>}
      {toolTipText && (
        <span class={`${Styles.tooltiptext}`}>{toolTipText}</span>
      )}
    </button>
  );
};

export default Button;
